import React from 'react';

import { Box, Grid } from '@mui/material';

import { IProjectedBalanceFieldTableProps } from './types';
import { ReadOnlyTableRow } from '../../../components/TableComponents/ReadOnlyTableRow';
import { TotalRowComponent } from '../../../components/TableComponents/TotalRowComponent';
import { getEachRowValues } from '../../../ProfitAndLossProjection/components/FormSections/NetSalesForm/helpers';

import styles from './ProjectedBalanceFieldTable.module.scss';

export const ProjectedBalanceFieldTable: React.FC<IProjectedBalanceFieldTableProps> = ({
  name,
  rows,
  firstColumnWidth = 250,
  totalRowTitle = '',
  rowTitles,
  totalName,
  period,
  totalValues,
  disabled
}) => {
  return (
    <Box className={styles.overflowBox}>
      <Grid container className={styles.container}>
        {rows.map((rowItem, index) => (
          <ReadOnlyTableRow
            key={rowTitles[index]}
            name={name}
            columnValues={getEachRowValues([rowItem], 0, period, true)}
            firstColumnWidth={firstColumnWidth}
            rowTitle={rowTitles[index]}
            noNeedName={true}
            disabled={disabled}
          />
        ))}
        <TotalRowComponent
          name={totalName}
          columnValues={getEachRowValues([totalValues], 0, period, true)}
          firstColumnWidth={firstColumnWidth}
          totalRowTitle={totalRowTitle}
          noNeedName={true}
          disabled={disabled}
        />
      </Grid>
    </Box>
  );
};
